import * as z from "zod/v4";
import { streamChannelNameSchema } from "./registry";
import { streamSubscriptionKeySchema } from "./session";

export const streamSubscribedMessageSchema = z.object({
  _tag: z.literal("subscribed"),
  subscriptionKey: streamSubscriptionKeySchema,
  channel: streamChannelNameSchema,
});
export type StreamSubscribedMessage = z.infer<
  typeof streamSubscribedMessageSchema
>;

export const streamInitialMessageSchema = z.object({
  _tag: z.literal("initial"),
  subscriptionKey: streamSubscriptionKeySchema,
  channel: streamChannelNameSchema,
  payload: z.unknown(),
});
export type StreamInitialMessage = z.infer<typeof streamInitialMessageSchema>;

export const streamEventMessageSchema = z.object({
  _tag: z.literal("event"),
  subscriptionKey: streamSubscriptionKeySchema,
  channel: streamChannelNameSchema,
  payload: z.unknown(),
});
export type StreamEventMessage = z.infer<typeof streamEventMessageSchema>;

export const streamUnsubscribedMessageSchema = z.object({
  _tag: z.literal("unsubscribed"),
  subscriptionKey: streamSubscriptionKeySchema,
  channel: streamChannelNameSchema,
});
export type StreamUnsubscribedMessage = z.infer<
  typeof streamUnsubscribedMessageSchema
>;

export const streamErrorMessageSchema = z.object({
  _tag: z.literal("error"),
  subscriptionKey: streamSubscriptionKeySchema.optional(),
  channel: streamChannelNameSchema.optional(),
  message: z.string(),
});
export type StreamErrorMessage = z.infer<typeof streamErrorMessageSchema>;

export const streamServerMessageSchema = z.discriminatedUnion("_tag", [
  streamSubscribedMessageSchema,
  streamInitialMessageSchema,
  streamEventMessageSchema,
  streamUnsubscribedMessageSchema,
  streamErrorMessageSchema,
]);
export type StreamServerMessage = z.infer<typeof streamServerMessageSchema>;
